import { render, staticRenderFns } from "./AddNewBar.vue?vue&type=template&id=66f2ee69"
import script from "./AddNewBar.vue?vue&type=script&lang=js"
export * from "./AddNewBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports